import { render, staticRenderFns } from "./AdminGeopointsTableRow.vue?vue&type=template&id=ba936e3c&"
import script from "./AdminGeopointsTableRow.vue?vue&type=script&lang=js&"
export * from "./AdminGeopointsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports